import { makeStyles } from '@material-ui/core/styles';
import { Colors } from '../../styles';

const useStyles = makeStyles((theme) => ({
  contentContainer: {
    padding: 12,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  header_actions: {
    color: Colors.APP_COLOR_HIGHLIGHT(),
    background: 'white',
    border: '1px solid white',
    marginLeft: '.5rem',
    '&:hover': {
      background: 'white',
    },
  },
  titleLayout: {
    padding: 20,
    backgroundColor: Colors.APP_COLOR_HIGHLIGHT(),
    color: 'white',
  },
  cardLayout: {
    marginBottom: 10,
  },
  back_button: {
    color: 'white',
    marginRight: '2rem',
  },
  subtitles: {
    padding: '1rem 0',
  },
  subtitle2: {
    marginTop: '.5rem',
    fontWeight: 'normal',
    marginBottom: '.5rem',
  },
  card: {
    background: 'white',
    borderRadius: '.5rem',
    padding: '2rem 1rem',
    border: '1px solid lightgray',
  },
}));

export default useStyles;
